<template>

  <el-dialog title="修改" :visible.sync="dialogVisible"
    @close="dialogFormVisible" :close-on-click-modal="false"
   :close-on-press-escape="false">
     <!--form表单-->
     <el-form size="small" ref="form" :model="form" :label-width="formLabelWidth">

    <el-form-item label="题目类型：">
        <el-radio-group v-model="form.code">
          <el-radio :label="'1'">单选题</el-radio>
          <el-radio :label="'2'">多选题</el-radio>
          <el-radio :label="'3'">填空题</el-radio>
        </el-radio-group>
    </el-form-item>

      
      <el-form-item label="题目：">
        <el-input v-model="form.name" placeholder="请输入题目"></el-input>
      </el-form-item>

      <el-form-item label="选项：" v-if="form.code != 3">
        <div><a @click="add_option">添加选项</a></div>
        <div >
            <div v-for="(item,index) in form.option" :key="index" style="display: flex;margin-bottom: 10px;">
              <el-input style="flex: 1;" v-model="item.numb" placeholder="请输入编号（对应着答案编号，A、B、C）"></el-input>
              <el-input style="flex: 1;margin-left: 10px;" v-model="item.title" placeholder="请输入选项"></el-input>
              <el-form-item label="图片"  :label-width="formLabelWidth" :rules="[{required: true,message: '请选择'}]">
              <el-row>
                <el-button icon="el-icon-picture-outline" @click="(event)=>openUpload(event,index)">选择图片</el-button>
                <div v-if="item.image" class="img">
                  <img :src="item.image" width="20" height="20" />
                </div>
              </el-row>
            </el-form-item>
              <div style="flex: 0.5;margin-left: 10px;" @click="del_option(index)">删除</div>
          </div>

        </div>
        
      </el-form-item>

      <el-form-item label="答案：">
        <el-input v-model="form.answer" placeholder="请填写编号（多个|隔开）例：A|B"></el-input>
        <div style="font-size: 10px;color: #999999;">（多个|隔开）例：A|B</div>
      </el-form-item>

      <el-form-item label="解析：">
        <el-input type="textarea" v-model="form.jiexi" placeholder="请输入解析"></el-input>
      </el-form-item>
      <el-form-item label="提示：">
        <el-input v-model="form.tip" placeholder="请输入提示（可不填）"></el-input>
      </el-form-item>
      <!-- <el-form-item label="难度：">
        <el-input v-model="form.level" placeholder="请输入难度（1~5，最小为最低难度）"></el-input>
      </el-form-item> -->
     
      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </el-dialog>
</template>

<script>
import ExamApi from '@/api/exam.js';
import Upload from '@/components/file/Upload';
import qs from 'qs';
export default {
  components:{
    Upload,
  },
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      /*是否显示*/
      dialogVisible: false,
      form:{
        image:"",
        name:"",//题目
        answer:"",//答案
        tip:"",//提示
        level:"",//难度
        jiexi:"",//答题解析
        option:[{
          id:"",
          numb:"A",
          title:"选项一",
        }],//选项
        code:"1",//1 单选题  2 多选题  3 填空题
      },
      isupload:false,
      /*列表数据*/
      tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          search: '',
          nickname:""
        },
    };
  },
  props: ['open',"exam_id"],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.getDetail();
        this.dialogVisible = this.open;
        
      }
    },
  },
  created(){
  
  },
  methods: {
    getDetail(){
      var self = this;
      var params = {
        exam_id:self.exam_id
      }
  
      ExamApi.detail(params, true)
        .then(data => {
          console.log( data);
          self.form = data.data;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    openUpload(e) {
        this.isupload = true;
      },
       /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.image = e[0].file_path;
      }
      this.isupload = false;
    },
    add_option(){
      this.form.option.push({
          id:"",
          numb:"A",
          title:"选项一",
      })
    },
    del_option(index){
      if(this.form.option.length == 1){
          self.$message({
            message: '至少保留一个选项',
            type: 'error'
          });
          return;
      }else{
        this.form.option.splice(index,1);
      }
     
    },
    /*添加*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = self.form;
      console.log(params)
      params.exam_id = self.exam_id;
      ExamApi.edit(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，添加成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
      },

    
       /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('close', {
            type: 'success',
            openDialog: false
          });
        } else {
          this.$emit('close', {
            type: 'error',
            openDialog: false
          });
        }
      },

  }
};
</script>

<style>
  .w150{
    width: 150px;
    border-collapse: collapse;
  }
  .tc{
    text-align: center;
    border-collapse: collapse;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/exam/part/Edit.vue